
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Method, File } from '../../types';
import * as API from '../../store/api';
@Component({})
export default class FileManager extends Vue {
  revalidate = 0;
  @Prop({ required: false, default: -1, type: Number }) maxFileNumber;
  @Prop({ required: false, default: 'Załączniki:', type: String }) headerText;
  @Prop({ required: false, default: '*', type: String }) allowedExtensions;
  @Prop({ required: true })
  saveData: any;
  @Prop({ required: true }) files;
  fileArray: File[] = [];
  deletedFiles: File[] = [];

  addAttachment() {
    document.getElementById('fileBuffer').click();
  }

  get canAddMoreFiles() {
    if (this.maxFileNumber === -1) return true;
    else if (this.maxFileNumber > this.fileArray.length) return true;
    else return false;
  }

  removeFile(file) {
    console.log('deleting file...');
    this.deletedFiles.push(file);
    this.fileArray = this.files.filter(el => el.id !== file.id);
  }

  async deleteMarkedFiles() {
    this.deletedFiles.forEach(async el => {
      API.removeFile(el.id);
    });
  }

  get getCurrentFiles() {
    return this.fileArray;
  }

  get mediaURL() {
    return process.env.VUE_APP_API_URL + 'media';
  }
  async sendFile(e) {
    console.log('Sending files', e.target.files);
    const form = new FormData();
    form.append('file', e.target.files[0]);
    form.append('guid', this.saveData.type === 'TMP' ? this.saveData.guid : '');
    form.append('data', JSON.stringify(this.saveData));
    form.append('filename', e.target.files[0].name);

    const response = await API.saveFile(form);
    if (response.data.success) {
      this.fileArray.push(response.data.file);
    }
  }

  @Watch('files')
  fileWatcher() {
    this.fileArray = this.files;
    this.deletedFiles = [];
  }

  mounted() {
    this.fileArray = this.files;
  }
}
